import { createApi, fetchBaseQuery, } from "@reduxjs/toolkit/query/react";
import { secureBaseQuery } from "./secureBaseQuery.js";
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";

export const headerApi = createApi({
  reducerPath: "headerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("accessToken");
      console.log({ token });

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
      //  baseQuery: dynamicBaseQuery,
  tagTypes: ["Header"],
  endpoints: (builder) => ({
    fetchHeader: builder.query({
      query: (data) => ({
        url: `/header/get-header-by-principalid/${data.id}?template_id=${data.template_id}`,
        method: "GET",
      }),
      providesTags: ["Header"],
    }),

    updateHeader: builder.mutation({
      query: (data) => ({
        url: `/header/update-header-template-map`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Header"],
    }),

    createHeader: builder.mutation({
      query: (data) => ({
        url: `/header/create-headers`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Header"],
    }),

    fetchHedersData: builder.query({
      query: () => ({
        url: `/header/header-template-map`,
        method: "GET",
      }),
      providesTags: ["Header"],
    }),

    fetchHeadersByPrincipalId: builder.query({
      query: (principalEntityId) => ({
        url: `/header/get-selected-headers`,
        params: { principalEntityId },
        method: "GET",
      }),
      providesTags: ["Header"],
    }),
    createHeaderManagement: builder.mutation({
      query: (data) => ({
        url: "/header/headers-management",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Header"],
    }),
    fetchHeadersByManagement: builder.query({
      query: (principalentity_id) => {
        const hasParam = principalentity_id
          ? `?principalentity_id=${principalentity_id}`
          : "";
        return {
          url: `/header/headers-management${hasParam}`,
          method: "GET",
        };
      },
      providesTags: ["Header"],
    }),

    updateHeaderManagement: builder.mutation({
      query: (data) => ({
        url: "/header/headers-management",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Header"],
    }),

    deleteHeaderManagement: builder.mutation({
      query: (header_id) => ({
        url: `/header/headers-management/${header_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Header"],
    }),
    getHeader: builder.query({
      query: (template_type) => ({
        url: `/header/headers-management/by-status?status=${template_type}`,
      }),
    }),
  }),
});

export const {
  useFetchHeaderQuery,
  useUpdateHeaderMutation,
  useCreateHeaderMutation,
  useFetchHedersDataQuery,
  useFetchHeadersByPrincipalIdQuery,
  useCreateHeaderManagementMutation,
  useFetchHeadersByManagementQuery,
  useUpdateHeaderManagementMutation,
  useDeleteHeaderManagementMutation,
  useGetHeaderQuery,
} = headerApi;
